import React from 'react';
import ReactDOM from 'react-dom';
import './styles.css';
import './index.css'; // Tailwind CSS 파일을 import
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));